module.exports = __webpack_public_path__ + "static/media/pr_details4.f038becf.jpg";